<template>
   <!--采购商指数-->
   <div id='hotCity' class='provide_container'></div>
</template>
<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/bar'
import { option as hotCityOption } from '@/zjljChartsConfig/hotCityOption.js' // 配置项
// import {option as dataResponse} from '@/zjljChartsConfig/provideData.js' //临时数据
export default{

  data () {
    return {
      xAxisData: [],
      dataStore19: [],
      dataStore18: [],
      showCount: 15, // 显示的数据数量
      showIndexPre: 0,
      showIndexLast: 30
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      http.get('/canmou/tianji/product/hot_purchase_citys?product_id=9008&county_id=2215').then(res => {
        this.dataResponse = res.data
        // 线数据
        this.dataStore19 = this.dataResponse.data.this_year_cnt
        this.dataStore18 = this.dataResponse.data.last_year_cnt
        // x轴数据
        this.xAxisDataStore = this.dataResponse.data.citys
        // 数据总数
        this.countAll = this.dataResponse.data.citys.length
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 初始化数据
    initOption () {
      this.data18 = this.dataStore18.slice(0, this.showCount)
      this.data19 = this.dataStore19.slice(0, this.showCount)

      this.xAxisData = this.xAxisDataStore.slice(0, this.showCount)
      // x轴数据
      hotCityOption.xAxis[0].data = this.xAxisData
      // 线数据
      hotCityOption.series = [{
        name: '今年采购商人数',
        type: 'bar',
        data: this.data19,
        barCategoryGap: 10, // 同个x坐标内的柱状图间距 px
        barGap: 0 // 几个柱状条的宽度
      }, {
        name: '去年采购商人数',
        type: 'bar',
        data: this.data18
      }]

      this.lineChart.setOption(hotCityOption)
    }
  },
  mounted () {
    this.lineChart = echarts.init(document.getElementById('hotCity'))
    // 改变数据设置动效
    var that = this
    let changeLinePoint = () => {
      if (that.showIndexLast > that.countAll) {
        that.showIndexPre = 0
        that.showIndexLast = that.showCount
      }

      that.data18.length = 0
      that.data18.push(...that.dataStore18.slice(that.showIndexPre, that.showIndexLast))

      that.data19.length = 0
      that.data19.push(...that.dataStore19.slice(that.showIndexPre, that.showIndexLast))

      that.xAxisData.length = 0
      that.xAxisData.push(...that.xAxisDataStore.slice(that.showIndexPre, that.showIndexLast))
      that.lineChart.setOption(hotCityOption)

      that.showIndexPre += that.showCount
      that.showIndexLast += that.showCount
      setTimeout(() => {
        // changeLinePoint();
      }, 2000)
    }
    // 获取数据
    this.getData(() => {
      // 处理返回数据
      this.initOption()
      // 设置数据切换
      changeLinePoint()
    })
  }
}

</script>
<style lang='less'>
  .provide_container{
    width: 100%;
    height:100%;
    background:none;
    padding:10px;
  }
</style>
